import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import HormoneDetailsFemale from "./HormoneDetailsFemale.jsx";
//import HormoneAddonPage from "./HormonesFemaleProfile/HormoneAddonPage.jsx"
import { useTranslation } from '../../../../language';

export default function BloodHormonesWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_hormon')}
      specify={t('page_sp_hormones_balance')}
      headlineNoWrap
      >

      <HormoneDetailsFemale />
      


    </PageProtectedLayout>

  );
}
